(ns common.schema.entities.lp-portal.lp-news-type
  (:require
   [common.schema.schema-utils :as su]))

(def schema
  (concat (su/text-simple-field :lp-news-type/display-name
                                "Display name"
                                {:not-clearable?   true
                                 :mandatory-config :mandatory/always
                                 :system-required? true
                                 :system-semantics
                                 su/user-provided-system-required-field-semantics
                                 :authorization    su/access-zadmin-lpg})
          (su/text-simple-field :lp-news-type/source-name "Source name" {:authorization su/access-zadmin-lpg})
          (su/text-simple-field :lp-news-type/source-id "Source id" {:authorization su/access-zadmin-lpg})
          (su/keyword-field :lp-news-type/source "Scraping source" nil {:authorization su/access-zadmin-lpg})))
